import { render, staticRenderFns } from "./DashboardCloseCockpit.vue?vue&type=template&id=3617dbb9&scoped=true&"
import script from "./DashboardCloseCockpit.vue?vue&type=script&lang=js&"
export * from "./DashboardCloseCockpit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCloseCockpit.vue?vue&type=style&index=0&id=3617dbb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617dbb9",
  null
  
)

export default component.exports